import {
    APPOINTMENT_DATE_CONFIRM_STATUS,
    APPOINTMENT_CONTRACTOR_PROPOSAL_STATUS,
    APPOINTMENT_CLIENT_APPROVAL_STATUS,
    APPOINTMENT_INVOICE_STATUS,
    APPOINTMENT_SENT_STATUS,
    APPOINTMENT_COMPLETE_STATUS,
    APPOINTMENT_CANCELED_STATUS,
} from 'pages/Appointments/constants';
import { AppointmentStatus } from 'types/appointment';

export const APPOINTMENT_STATUS_LABELS: Record<AppointmentStatus, string> = {
    [APPOINTMENT_DATE_CONFIRM_STATUS]: 'Awaiting Date Confirmation',
    [APPOINTMENT_CONTRACTOR_PROPOSAL_STATUS]: 'Awaiting Contractor Proposal',
    [APPOINTMENT_CLIENT_APPROVAL_STATUS]: 'Awaiting Client Approval',
    [APPOINTMENT_INVOICE_STATUS]: 'Awaiting Invoice',
    [APPOINTMENT_SENT_STATUS]: 'Invoice Sent',
    [APPOINTMENT_COMPLETE_STATUS]: 'Complete',
    [APPOINTMENT_CANCELED_STATUS]: 'Canceled',
};

export const APPOINTMENT_STATUS_COLORS: Record<AppointmentStatus, string> = {
    [APPOINTMENT_DATE_CONFIRM_STATUS]: '#5D5F62',
    [APPOINTMENT_CONTRACTOR_PROPOSAL_STATUS]: '#5954D3',
    [APPOINTMENT_CLIENT_APPROVAL_STATUS]: '#D79B00',
    [APPOINTMENT_INVOICE_STATUS]: '#FE9727',
    [APPOINTMENT_SENT_STATUS]: '#0F6CBD',
    [APPOINTMENT_COMPLETE_STATUS]: '#459B64',
    [APPOINTMENT_CANCELED_STATUS]: '#E15C4F',
};
